// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"90dc0b3f","53":"646df169","224":"4b4c4c3e","312":"01fb1758","363":"9ece2dc5","394":"1b2c947a","425":"e1712841","553":"c61f96a9","608":"3fa79da7","661":"e6fca573","913":"2b214f6d"}[chunkId] + ".chunk.js";
};